import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CInputGroup,
  CFormInput,
  CSpinner
} from '@coreui/react';
import { useTranslation } from 'react-i18next';
import CIcon from '@coreui/icons-react';
import { cilSearch, cilTrash, cilPencil, cilPeople } from '@coreui/icons';

const AdminUsers = () => {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const loadUsers = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getUsers({ search: searchTerm });
      setUsers(response.data.users || []);
    } catch (error) {
      console.error('Failed to load users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      loadUsers();
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Users are already filtered by API

  if (loading) {
    return (
      <div className="text-center py-5">
        <CSpinner />
      </div>
    );
  }

  return (
    <div className="admin-users">
      <CCard>
        <CCardHeader className="d-flex justify-content-between align-items-center">
          <h2 className="admin-page-title mb-0">{t('admin.users') || 'Users'}</h2>
          <CInputGroup style={{ width: '300px' }}>
            <CFormInput
              placeholder={t('common.search') || 'Search...'}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <CButton type="button" color="secondary">
              <CIcon icon={cilSearch} />
            </CButton>
          </CInputGroup>
        </CCardHeader>
        <CCardBody>
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell>
                <CTableHeaderCell>{t('auth.firstName')}</CTableHeaderCell>
                <CTableHeaderCell>{t('auth.lastName')}</CTableHeaderCell>
                <CTableHeaderCell>{t('auth.email')}</CTableHeaderCell>
                <CTableHeaderCell>{t('auth.phone')}</CTableHeaderCell>
                <CTableHeaderCell>{t('profile.subscription')}</CTableHeaderCell>
                <CTableHeaderCell>{t('admin.actions')}</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {users.map((user) => (
                <CTableRow key={user.id}>
                  <CTableDataCell className="text-center">
                    <div className="avatar-sm bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', margin: '0 auto' }}>
                      <span className="text-white fw-bold">
                        {user.firstName?.[0] || ''}{user.lastName?.[0] || ''}
                      </span>
                    </div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{user.firstName}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{user.lastName}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{user.email}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{user.phone || '-'}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    {user.isPremium ? (
                      <span className="badge bg-warning">Premium</span>
                    ) : (
                      <span className="badge bg-secondary">Free</span>
                    )}
                  </CTableDataCell>
                  <CTableDataCell>
                    <CButton color="primary" variant="outline" size="sm" className="me-2">
                      <CIcon icon={cilPencil} />
                    </CButton>
                    <CButton color="danger" variant="outline" size="sm">
                      <CIcon icon={cilTrash} />
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
          
          {users.length === 0 && (
            <div className="text-center py-5">
              <p className="text-muted">{t('admin.noUsers') || 'No users found'}</p>
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default AdminUsers;

